import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircleIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen bg-gradient-to-b from-zinc-950 via-zinc-900 to-zinc-950 overflow-hidden" data-id="element-132">
      {/* Background glow effect */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-emerald-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-133" />

      <div className="relative max-w-4xl mx-auto px-4 pt-12 pb-16 sm:pt-20 sm:pb-24" data-id="element-134">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-6" data-id="element-135">
          <span className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-sm font-medium px-4 py-2 rounded-full" data-id="element-136">
            <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" data-id="element-137" />
            Actualizado 2025
          </span>
        </motion.div>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-center text-white leading-tight mb-6" data-id="element-138">
          El método de <span className="text-emerald-400" data-id="element-139">7 pasos</span> que
          nadie te está mostrando para tener{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400" data-id="element-140">
            Magis TV
          </span>{' '}
          funcionando en menos de{' '}
          <span className="text-amber-400" data-id="element-141">15 minutos</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg sm:text-xl text-zinc-400 text-center max-w-2xl mx-auto mb-8" data-id="element-142">
          La única guía visual, actualizada y a prueba de errores que te lleva
          desde cero hasta tener{' '}
          <strong className="text-white" data-id="element-143">
            +1.000 canales en tu celular y Smart TV
          </strong>{' '}
          — sin tecnicismos, sin frustraciones.
        </motion.p>

        {/* Trust indicators */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-10" data-id="element-144">
          <div className="flex items-center gap-2 text-zinc-400 text-sm" data-id="element-145">
            <CheckCircleIcon className="w-5 h-5 text-emerald-500" data-id="element-146" />
            <span data-id="element-147">Capturas reales</span>
          </div>
          <div className="flex items-center gap-2 text-zinc-400 text-sm" data-id="element-148">
            <ClockIcon className="w-5 h-5 text-emerald-500" data-id="element-149" />
            <span data-id="element-150">15 minutos</span>
          </div>
          <div className="flex items-center gap-2 text-zinc-400 text-sm" data-id="element-151">
            <PlayCircleIcon className="w-5 h-5 text-emerald-500" data-id="element-152" />
            <span data-id="element-153">Android + Smart TV</span>
          </div>
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col items-center gap-4" id="cta" data-id="element-154">
          <a href="#precio" className="group relative inline-flex items-center justify-center bg-gradient-to-r from-emerald-500 to-emerald-400 hover:from-emerald-400 hover:to-emerald-300 text-black font-black text-lg sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-emerald-500/30" data-id="element-155">
            <span className="relative z-10" data-id="element-156">SÍ, QUIERO LA GUÍA AHORA</span>
            <div className="absolute inset-0 rounded-xl bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-157" />
          </a>
          <p className="text-zinc-500 text-sm" data-id="element-158">
            Acceso inmediato • Garantía 100%
          </p>
        </motion.div>

        {/* Visual element - TV mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mt-12 sm:mt-16 relative" data-id="element-159">
          <div className="relative mx-auto max-w-2xl" data-id="element-160">
            {/* TV Frame */}
            <div className="bg-zinc-800 rounded-2xl p-3 shadow-2xl" data-id="element-161">
              <div className="bg-gradient-to-br from-zinc-900 to-black rounded-xl aspect-video flex items-center justify-center relative overflow-hidden" data-id="element-162">
                {/* Screen content */}
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/5 to-cyan-500/5" data-id="element-163" />
                <div className="text-center p-6" data-id="element-164">
                  <div className="text-6xl sm:text-8xl mb-4" data-id="element-165">📺</div>
                  <p className="text-emerald-400 font-bold text-lg sm:text-xl" data-id="element-166">
                    +1.000 Canales
                  </p>
                  <p className="text-zinc-500 text-sm mt-1" data-id="element-167">
                    Películas • Series • Deportes • En Vivo
                  </p>
                </div>
                {/* Scan line effect */}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/5 to-transparent opacity-30 animate-pulse" data-id="element-168" />
              </div>
            </div>
            {/* TV Stand */}
            <div className="mx-auto w-24 h-3 bg-zinc-800 rounded-b-lg" data-id="element-169" />
            <div className="mx-auto w-40 h-2 bg-zinc-700 rounded-full mt-1" data-id="element-170" />
          </div>
        </motion.div>
      </div>
    </section>;
}